import React, { useEffect, useState } from "react";

function compute(target) {
    const now = new Date();
    const diff = target.getTime() - now.getTime();
    if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / (1000 * 60)) % 60);
    const s = Math.floor((diff / 1000) % 60);
    return { d, h, m, s, done: false };
}

function targetDate() {
    // Launching 4th July — pick nearest 4 July (this year or next)
    const now = new Date();
    let target = new Date(Date.UTC(now.getUTCFullYear(), 6, 4, 0, 0, 0));
    if (target.getTime() < now.getTime()) {
        target = new Date(Date.UTC(now.getUTCFullYear() + 1, 6, 4, 0, 0, 0));
    }
    return target;
}

function Cell({ v, label, testid }) {
    return (
        <div className="card-surface p-6 md:p-8 flex-1 min-w-0" data-testid={testid}>
            <div className="font-mono text-4xl md:text-6xl font-medium tabular-nums tracking-tight text-white">
                {String(v).padStart(2, "0")}
            </div>
            <div className="eyebrow mt-3">{label}</div>
        </div>
    );
}

export default function Countdown() {
    const [target] = useState(() => targetDate());
    const [t, setT] = useState(() => compute(target));

    useEffect(() => {
        const id = setInterval(() => setT(compute(target)), 1000);
        return () => clearInterval(id);
    }, [target]);

    return (
        <div className="relative" data-testid="launch-countdown">
            <div className="flex items-end gap-3 md:gap-4 mb-6">
                <span className="eyebrow">Launching</span>
                <span className="hairline flex-1 mb-1" />
                <span className="eyebrow font-mono">04 · 07 · {target.getUTCFullYear()}</span>
            </div>

            <div className="grid grid-cols-4 gap-3 md:gap-4">
                <Cell v={t.d} label="Days" testid="cd-days" />
                <Cell v={t.h} label="Hours" testid="cd-hours" />
                <Cell v={t.m} label="Minutes" testid="cd-minutes" />
                <Cell v={t.s} label="Seconds" testid="cd-seconds" />
            </div>
        </div>
    );
}
